import React from 'react';
import ReactDOM from 'react-dom/client';
import { flushSync } from 'react-dom';
import App from './components/App';
import './assets/sass/style.scss';
import './i18n';
import { RecoilRoot } from 'recoil';
import { startup } from './services/startup';
import { allElementsState, authState } from './states/atoms';

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

const render = () => {
  root.render(
    <React.StrictMode>
      <RecoilRoot
        initializeState={({ set }) => {
          if (startup.isReady) {
            set(authState, startup.isAuthenticated);
            set(allElementsState, startup.allElements);
          }
        }}
      >
        <App />
      </RecoilRoot>
    </React.StrictMode>
  );
};

// В пререндеренной странице (build/<lang>/.../index.html) готовый контент уже на экране.
// Первый рендер React заменяет содержимое #root, поэтому ждём стартовые данные и рисуем сразу
// всю страницу: без лоадера поверх контента и без позднего LCP. В пустой оболочке — как раньше, сразу.
if (container.childElementCount > 0) {
  startup.ready.then(() => {
    // Прокрутку, сделанную до готовности приложения, переносим на новый DOM
    const scrolled = [...document.querySelectorAll('.read-element__container, .element-list__container, .element-list__list')]
      .map(element => [element.className, element.scrollTop]);
    const { scrollX, scrollY } = window;
    flushSync(render);
    scrolled.forEach(([className, scrollTop]) => {
      const element = document.getElementsByClassName(className)[0];
      if (element && scrollTop) {
        element.scrollTop = scrollTop;
      }
    });
    window.scrollTo(scrollX, scrollY);
  });
} else {
  render();
}

// Service Worker не регистрируем: CRA собирает его только из src/service-worker.js, а здесь его нет —
// регистрация /service-worker.js получала HTML, падала с ошибкой в консоли и была лишним запросом
